<template>
  <main class="ai-mails">
    <header class="mail-header"><div><h1>Mailbearbeitung</h1><p class="muted">Kundenanliegen einordnen und mit vorbereiteten Vertragsdaten bearbeiten.</p></div>
      <nav class="mail-actions"><router-link class="mail-link" to="/dashboard"><span aria-hidden="true">←</span> Zurück zum Dashboard</router-link><router-link class="mail-link" to="/ai/mail">Bisherige Mailansicht</router-link><router-link v-if="canAdmin" class="mail-link" to="/ai/mails/admin">Verwaltung</router-link><button :disabled="scanning" @click="scan">{{ scanning ? 'Gleicht ab …' : 'Mails abgleichen' }}</button></nav></header>
    <p v-if="error" class="mail-notice error" role="alert">{{ error }}</p>
    <div class="mail-layout"><mail-list :rows="rows" :total="total" :page="page" :loading="loading" :selected="selected" @select="selected = $event" @filter="filter" @page="changePage" />
      <mail-detail v-if="selected" :key="selected" :id="selected" @changed="load(false)" /><section v-else class="mail-card mail-empty">Wähle eine Mail aus, um sie zu bearbeiten.</section></div>
  </main>
</template>
<script>
import api, { errorText } from "@/api/aiMails"
import userService from "@/services/userService"
import MailList from "@/components/ai/mails/MailList.vue"
import MailDetail from "@/components/ai/mails/MailDetail.vue"
import "@/components/ai/mails/mails.css"
export default {
  components: { MailList, MailDetail },
  data: () => ({ rows: [], total: 0, page: 1, selected: "", loading: false, scanning: false, error: "", filters: {}, timer: null, requestId: 0, stopped: false }),
  computed: { canAdmin() { return userService.hasRight("ai_mail_admin", "g_manageRights") } },
  mounted() { this.load(); this.timer = setInterval(() => this.load(false), 10000) },
  beforeDestroy() { this.stopped = true; clearInterval(this.timer) },
  methods: {
    async load(show = true) { const requestId = ++this.requestId; if (show) this.loading = true
      try { const result = await api.list({ ...this.filters, page: this.page }); if (this.stopped || requestId !== this.requestId) return
        this.rows = result.rows; this.total = result.total; this.error = ""
      } catch (error) { if (requestId === this.requestId) this.error = errorText(error) } finally { if (requestId === this.requestId) this.loading = false } },
    filter(values) { this.filters = { ...values, closed: values.closed ? "1" : "0" }; this.page = 1; this.load() },
    changePage(page) { this.page = page; this.load() },
    async scan() { this.scanning = true; this.error = ""; try { await api.scan(); await this.load() } catch (error) { this.error = errorText(error) } finally { this.scanning = false } },
  },
}
</script>
